import { createContext, useContext } from 'react';

import noop from 'utils/noop';

export interface FieldsFilterState {
  changeSearch: (value: string) => void;
  search: string;
}

const defaultContext: FieldsFilterState = {
  changeSearch: noop,
  search: '',
};

export const FieldsFilterContext = createContext<FieldsFilterState>(defaultContext);

export const useFieldsFilterContext = () => useContext(FieldsFilterContext);
